"use strict";
// https://github.com/OliverJAsh/simple-maybe
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = function (maybeT) {
    return maybeT !== undefined && maybeT !== null;
};
// extend {} to ensure we're mapping to a non-null type
exports.mapMaybe = function (maybeT, f) {
    return exports.isDefined(maybeT) ? f(maybeT) : maybeT;
};
exports.getOrElseMaybe = function (maybeT, fallback) {
    return exports.isDefined(maybeT) ? maybeT : fallback();
};
//# sourceMappingURL=maybe.js.map